import { render, staticRenderFns } from "./ProductionCapacityExport.vue?vue&type=template&id=9718f0f6"
import script from "./ProductionCapacityExport.vue?vue&type=script&lang=js"
export * from "./ProductionCapacityExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports